export default {
  title: {
    ar: 'لقد شاركت في اختبار اليوم. عُد غدًا للمشاركة مجددًا!',
    en: 'You\'ve already played today\'s quiz.'
  },

  description: {
    ar: '',
    en: 'Come back tomorrow to play again!'
  },

  button: {
    ar: 'العودة إلى الصفحة الرئيسية',
    en: 'Back to Homepage'
  },

  terms: {
    ar: '',
    en: 'Have a look at the'
  },

  termsLabel: {
    ar: 'اطلع على الشروط والأحكام',
    en: 'Terms & Conditions'
  },

  termsLink: {
    ar: 'https://storage.googleapis.com/media-mcd-uae-fanshop-prod/terms/Brand_Trust_Game.pdf?openOutsideMcd=true',
    en: 'https://storage.googleapis.com/media-mcd-uae-fanshop-prod/terms/Brand_Trust_Game.pdf?openOutsideMcd=true'
  }
};
